//--------------------------------------------------
// imported classes
//--------------------------------------------------
const BaseMediator = require('@/tbs/controller/BaseMediator')
const ClassFunc = require('@/tbs/util/ClassFunc')
const Staff = require('@/tbs/model/vo/Staff')
const DataConvertor = require('@/tbs/core/DataConvertor')
const Passport = require('@/libs/passport')
// const ModelLocator = require('@/tbs/model/ModelLocator')

/**
 * The MatchMediator class maintains the business logic
 * for the organization.
 */
const tbs_controller_StaffInviteMediator = function() {
    //--------------------------------------------------
    // super method for the base class
    //--------------------------------------------------
    ClassFunc.super(this, BaseMediator, arguments)
    // console.log('tbs_controller_StaffInviteMediator constructor')
}

//--------------------------------------------------
// prototype
//--------------------------------------------------
tbs_controller_StaffInviteMediator.prototype = {
    //--------------------------------------------------
    // api method
    //--------------------------------------------------
    /**
     * @api
     * Handle the creation complete condition triggered by 
     * the scene instance.
     */
    handleCreationComplete: function() {
        console.log('handleCreationComplete')
        const current = this._bridge.getRouteName()
        if (current == 'OrgInviteStaff') {
            this.fetchInviteInfo(this._bridge.getRouteQuery('ticket'))
        }
        else if (current == 'OrgAcceptStaff') {
            this.target().staff = this._bridge.getRouteQuery()
        }
    },
    handleCustomEvent: function(event) {
        console.log('handleCustomEvent', event)
        if (event.type == 'join') {
            this.joinOrganization()
        }
    },
    handleRouteBack: function() {
        console.log('nothing')
    },
    joinOrganization: function() {
        const self = this
        // validate the passport and prepair the one
        Passport.getPassport().then(res => {
            console.log('getPassport', res)
            if (res) {
                self.acceptInvitation(self._bridge.getRouteQuery('ticket'))
            }
        })
    },
    acceptInvitation: function(ticket) {
        console.log('fetchInviteInfo', ticket)
        const self = this
        const staff = new Staff
        const source = staff.view.accept
        const service = 'acceptStaffInvite'
        const parameters = {
            ticket: ticket
        }
        self._bridge.addResourceListener(service, function(e) {
            self._bridge.removeResourceListener(service, e.handler)
            console.log('accept.data', service, e.data)
            self._bridge.goToScene('OrgAcceptStaff', {}, {
                roleLabel: self.target().staff.roleLabel,
                organizationName: self.target().staff.organizationName
            })
        })
        self._bridge.callResourceInstance(service, {
            baseUrl: source.baseUrl,
            apiPrefix: source.apiPrefix,
            apiSuffix: source.apiSuffix,
            serviceName: source.service,
            method: 'GET',
            parameters: parameters
        })
    },
    fetchInviteInfo: function(ticket) {
        console.log('fetchInviteInfo', ticket)
        const self = this
        const staff = new Staff
        const source = staff.view.invite
        const service = 'inviteStaff'
        const parameters = {
            ticket: ticket
        }
        self._bridge.addResourceListener(service, function(e) {
            self._bridge.removeResourceListener(service, e.handler)
            console.log('send.data', service, e.data)
            const viewData = DataConvertor.transform(staff, e.data.payload, 'invite')
            const wrapper = DataConvertor.wrapper(staff)
            console.log('@wrapper-viewData', wrapper, viewData)
            self.target()[wrapper] = viewData
        })
        self._bridge.callResourceInstance(service, {
            baseUrl: source.baseUrl,
            apiPrefix: source.apiPrefix,
            apiSuffix: source.apiSuffix,
            serviceName: source.service,
            method: 'GET',
            parameters: parameters
        })
    }
}

//--------------------------------------------------
// extends the BaseMediator
//--------------------------------------------------
ClassFunc.extend(tbs_controller_StaffInviteMediator, BaseMediator);

module.exports = tbs_controller_StaffInviteMediator